/* src/app/private/components/view/update-orgnaization/update-orgnaization.component.scss */
.field {
  display: flex;
  gap: 1rem;
}
label {
  font-size: 1rem;
  font-weight: 500;
  color: var(--p-text-color);
}
/*# sourceMappingURL=update-orgnaization.component.css.map */
